/**
 * NativeWind/Reanimated regression (web only): Animated.* components have className
 * silently dropped because NativeWind only registers core RN components by default.
 * Re-registers them via cssInterop for web. Import once at app startup.
 */
import Animated from 'react-native-reanimated'
import { cssInterop } from 'nativewind'
import { Platform, Pressable } from 'react-native'
import { BlurView } from 'expo-blur'

export const AnimatedPressable = Animated.createAnimatedComponent(Pressable)
export const AnimatedBlurView = Animated.createAnimatedComponent(BlurView)

// Workaround: reanimated styles broken on web — re-register with cssInterop until fixed upstream.
if (Platform.OS === 'web') {
  cssInterop(Animated.View, { className: 'style' })
  cssInterop(Animated.Text, { className: 'style' })
  cssInterop(Animated.ScrollView, {
    className: 'style',
    contentContainerClassName: 'contentContainerStyle',
  })
  cssInterop(Animated.FlatList, {
    className: 'style',
    contentContainerClassName: 'contentContainerStyle',
  })
  cssInterop(Animated.Image, { className: 'style' })
  cssInterop(AnimatedPressable, { className: 'style' })
  cssInterop(AnimatedBlurView, { className: 'style' })
}
